import { getField, updateField } from 'vuex-map-fields'

const parseExpense = function(expense){
  let item = {
    id: expense.id,
    for_attach: false,
    for_destroy: false,
    cost_type: expense.cost_type,
    cost_description: expense.cost_description,
    amount: expense.amount,
    currency: expense.currency,
    receipt: {},
    isReceivedRefund: "skip"
  }
  if (expense.receipt.url) {
    item.receipt = {
      name: expense.receipt.name,
      url: expense.receipt.access_link
    }
  }
  return item
}

const newExpense = function() {
  return {
    id: '_' + Math.random().toString(36).substr(2, 9),
    for_attach: true,
    for_destroy: false,
    cost_type: '',
    cost_description: '',
    amount: '',
    currency: 'EUR',
    receipt: {},
    isReceivedRefund: undefined
  }
}

// cost_type - required
// cost_description - optional
// amount - required format 00.00
// currency - required default eur
// receipt - optional one file images/pdf/doc/docx
const defaultState = {
  is_expenses: false, // true/false
  list: []
}

const actions = {}

const mutations = {

  updateField,

  FETCH(state, extra_expenses) {
    state.is_expenses = !!extra_expenses.length
    state.list = []
    extra_expenses.map((expense) => {
      state.list.push(parseExpense(expense))
    })
  },

  TOGGLE(state, value) {
    state.is_expenses = value
    state.list.map((expense) => expense.for_destroy = !value)
  },

  ADD(state) {
    state.list.push(Object.assign({}, newExpense()))
  },

  REMOVE(state, id) {
    let index = state.list.findIndex(expense => expense.id == id)
    let expense = state.list[index]
    if (expense.for_attach) {
      state.list.splice(index, 1)
    } else {
      expense.for_destroy = true
    }
  },

  SET_RECEIPT(state, payload) {
    let { index, file } = payload
    state.list[index].receipt = {
      name: file.name,
      doc: file,
      type: file.type,
      url: URL.createObjectURL(file)
    }
  }
}

const getters = {
  getField
}

export default {
  namespaced: true,
  state: defaultState,
  actions: actions,
  mutations: mutations,
  getters: getters
}
